// extracted by mini-css-extract-plugin
export default {"root":"IconShipping_root__aFDEC"};